import type { SeatView, TableModel } from '../model/table.ts';
import type { BrickInstance } from '../presentation/types.ts';
import { parseSelector, selectCounters } from '../presentation/selectors.ts';

/** Repeat only observed seat owners selected by an optional counter domain. */
export function seatsFor(inst: BrickInstance, seats: SeatView[], table?: Pick<TableModel, 'counters' | 'selfSeat'>): SeatView[] {
  let list = inst.over === 'opponents' ? seats.filter(s => !s.isSelf) : seats;
  if (inst.select && table) {
    const selector = parseSelector(inst.select);
    const owners = new Set(typeof selector === 'string' ? [] : selectCounters(selector, table.counters, null, table.selfSeat).map(c => c.owner));
    list = list.filter(s => owners.has(s.id));
  }
  if (inst.order === 'self-first') list = [...list.filter(s => s.isSelf), ...list.filter(s => !s.isSelf)];
  return list;
}
